import {
  ALL_PERMISSIONS,
  type PermissionId,
  type PermissionName,
} from "./catalog";
import { getPermissionId } from "./lookup";

export const MODULES = {
  users: {
    prefix: "user",
    listRoute: null,
    createRoute: null,
  },
  roles: {
    prefix: "role",
    listRoute: null,
    createRoute: null,
  },
  permissions: {
    prefix: "permission",
    listRoute: null,
    createRoute: null,
  },
  categories: {
    prefix: "categories",
    listRoute: null,
    createRoute: null,
  },
  tags: {
    prefix: "tags",
    listRoute: null,
    createRoute: null,
  },
  settings: {
    prefix: "settings",
    listRoute: null,
    createRoute: null,
  },
  branches: {
    prefix: "branch",
    listRoute: null,
    createRoute: null,
  },
  items: {
    prefix: "items",
    listRoute: "/items/raw-materials",
    createRoute: "/items/create-item",
  },
  variants: {
    prefix: "variants",
    listRoute: null,
    createRoute: null,
  },
  preparedItems: {
    prefix: "preparedItems",
    listRoute: "/items/prepared-items",
    createRoute: "/items/create-prepared-item",
  },
  suppliers: {
    prefix: "supplier",
    listRoute: "/suppliers",
    createRoute: "/suppliers/create-supplier",
  },
  purchaseOrders: {
    prefix: "po",
    listRoute: "/purchase-orders",
    createRoute: "/purchase-orders/create-order",
  },
  receiving: {
    prefix: "po",
    listRoute: "/receiving-qc",
    createRoute: null,
  },
  inventory: {
    prefix: "inventory",
    listRoute: "/inventory",
    createRoute: null,
  },
  openingBalance: {
    prefix: "openingBalance",
    listRoute: "/inventory/set-opening-balance",
    createRoute: "/inventory/set-opening-balance",
  },
  transfers: {
    prefix: "transfer",
    listRoute: "/transfers",
    createRoute: "/transfers/create-transfer",
  },
  incomingRequests: {
    prefix: "transfer",
    listRoute: "/incoming-requests",
    createRoute: null,
  },
  requestsSent: {
    prefix: "branchRequestPreparedItem",
    listRoute: "/requests-sent",
    createRoute: "/requests-sent/create",
  },
  ckPreparedItemRequests: {
    prefix: "ckRequestPreparedItem",
    listRoute: "/prepared-item-requests",
    createRoute: null,
  },
} as const;

export type ModuleKey = keyof typeof MODULES;
export type PermissionModulePrefix = (typeof MODULES)[ModuleKey]["prefix"];

/** Module part before the first "." */
export function getPermissionModulePart(name: string): string {
  const dotIndex = name.indexOf(".");
  return dotIndex >= 0 ? name.slice(0, dotIndex) : name;
}

export function getModulePrefix(module: ModuleKey): PermissionModulePrefix {
  return MODULES[module].prefix;
}

export function moduleAnyOf(prefix: PermissionModulePrefix): PermissionName[] {
  return ALL_PERMISSIONS.filter(
    (permission) => getPermissionModulePart(permission.name) === prefix,
  ).map((permission) => permission.name);
}

export function getModulePermissionIds(
  prefix: PermissionModulePrefix,
): readonly PermissionId[] {
  return moduleAnyOf(prefix).map((name) => getPermissionId(name));
}
